/* lystia-buybox.js - BuyBox PDP (T-E4-04; parity/pdp-buybox.md §3-§5, §7). Розмітка і тексти - snippets/pdp-buybox.liquid
   (шаблони <template data-bb-tpl>, дані варіантів <script data-bb-data>, тексти в data-text-* на [data-bb-zone]).
   Підключення: <script src="{{ 'lystia-buybox.js' | asset_url }}" defer> (після lystia-core/cart/qty/toast/overlay).
   Робить: вибір варіанта (чіпи, мітка, мета ціни, replaceState ?variant=, подія document `variant:change` {id, price, compareAt} у копійках),
   зона купівлі (default / loading / added / error / OOS / єдиний екземпляр) через window.LystiaCart (Cart AJAX), sticky-бар M (IO + scroll),
   тост «Додано в кошик». Подія `pdp:added` {id, quantity} на document - для upsell (T-E4-05). Глобалів немає. */
(function () {
  'use strict';

  var NBSP = ' ';

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function tpl(zone, name) {
    var t = qs('template[data-bb-tpl="' + name + '"]', zone);
    return t ? t.content.cloneNode(true) : document.createDocumentFragment();
  }

  function fmtMoney(cents, cur) {
    var s = String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
    return s + NBSP + cur;
  }

  function toast(text, opts) {
    if (text && document.lystiaToast) document.lystiaToast.show(text, opts || {});
  }

  class Buybox {
    constructor(root, zone) {
      this.root = root;
      this.zone = zone;
      this.body = qs('[data-bb-body]', zone);
      var d = zone.dataset;
      this.T = d;
      this.cur = d.currency || '';
      this.single = d.single === 'true';
      try { this.variants = JSON.parse(qs('script[data-bb-data]', zone).textContent) || []; } catch (e) { this.variants = []; }
      var id = Number(d.current);
      this.v = this.variants.filter(function (x) { return x.id === id; })[0] || this.variants[0];
      this.qty = 1;
      this.error = false;
      this.busy = false;
      this.silent = false;
      this.sticky = null;
      this.stickyBtn = null;
      this.chips = qs('[data-bb-chips]', root);
      this.selVal = qs('[data-bb-sel-val]', root);
      this.mqD = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : null;
      this.bind();
      this.buildSticky();
      this.draw();
      this.drawSticky();
      this.watchSticky();
      this.syncCart();
    }

    /* ---------- кошик ---------- */
    get cart() { return window.LystiaCart || null; }

    inCart() { return this.cart && this.v ? this.cart.qtyOf(this.v.id) : 0; }

    syncCart() {
      var self = this;
      if (!this.cart) return;
      this.cart.get().then(function () { self.draw(); self.drawSticky(); }, function () {});
    }

    openCart() {
      var ov = document.lystiaOverlay;
      if (ov && ov.has && ov.has('cart')) ov.open('cart');
      else if (this.T.cartUrl) window.location.assign(this.T.cartUrl);
    }

    /* ---------- події ---------- */
    bind() {
      var self = this;
      if (this.chips) {
        this.chips.addEventListener('click', function (e) {
          var b = e.target.closest ? e.target.closest('.pdp__chip') : null;
          if (b) self.select(Number(b.dataset.vid));
        });
      }
      this.zone.addEventListener('click', function (e) {
        var add = e.target.closest ? e.target.closest('[data-bb-add]') : null;
        if (!add) return;
        e.preventDefault();
        if (self.inCart()) self.openCart(); else self.add(false);
      });
      this.zone.addEventListener('submit', function (e) { e.preventDefault(); });
      this.zone.addEventListener('lystia-qty:change', function (e) { self.onQty(e.detail.value); });
      document.addEventListener('cart:change', function () {
        if (self.silent) { self.drawSticky(); return; }
        self.draw();
        self.drawSticky();
      });
      document.addEventListener('lystia:overlay-open', function () { self.updateSticky(); });
      document.addEventListener('lystia:overlay-close', function () { self.updateSticky(); });
    }

    onQty(n) {
      var self = this;
      var cart = this.cart;
      var item = cart && cart.cart ? cart.cart.items.filter(function (i) { return i.variant_id === self.v.id; })[0] : null;
      if (!item) { this.qty = n; return; }
      this.silent = true;
      cart.setQty(item.key, n).then(function () {
        self.silent = false;
        self.drawSticky();
      }, function () {
        self.silent = false;
        self.draw();
        self.drawSticky();
      });
    }

    /* ---------- вибір варіанта ---------- */
    select(id) {
      var v = this.variants.filter(function (x) { return x.id === id; })[0];
      if (!v || v.id === this.v.id) return;
      this.v = v;
      this.qty = 1;
      this.error = false;
      qsa('.pdp__chip', this.root).forEach(function (c) {
        var on = Number(c.dataset.vid) === id;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      if (this.selVal) this.selVal.textContent = v.label;
      qsa('[data-pdp-price-meta]', this.root).forEach(function (m) { m.textContent = v.meta; });
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: { id: v.id, price: v.price, compareAt: v.compare > v.price ? v.compare : null }
      }));
      this.draw();
      this.drawSticky();
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', String(v.id));
        window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
      } catch (e) { /* без replaceState */ }
    }

    /* ---------- зона купівлі ---------- */
    setLoading(btn, on, label) {
      if (!btn) return;
      btn.classList.toggle('is-loading', on);
      btn.setAttribute('aria-busy', on ? 'true' : 'false');
      var sp = qs('.spinner', btn);
      if (on && !sp) btn.insertBefore(tpl(this.zone, 'spinner'), btn.firstChild);
      if (!on && sp) sp.remove();
      if (label != null) qs('.btn__label', btn).textContent = label;
    }

    draw() {
      var z = this.zone, body = this.body, v = this.v;
      if (!body || !v) return;
      var focused = body.contains(document.activeElement) && document.activeElement.closest('[data-bb-add]');
      body.replaceChildren();
      if (!v.available) {
        body.appendChild(tpl(z, 'na'));
        return;
      }
      var inCart = this.inCart();
      var frag = tpl(z, 'atc');
      var atc = qs('[data-bb-atc]', frag);
      var btn = qs('[data-bb-add]', frag);
      var label = qs('.btn__label', btn);
      if (this.error) {
        body.appendChild(tpl(z, 'err'));
      }
      if (inCart) {
        btn.classList.remove('btn--primary');
        btn.classList.add('btn--secondary', 'is-added');
        btn.insertBefore(tpl(z, 'check'), label);
        label.textContent = this.T.textAdded;
      } else {
        label.textContent = this.T.textAdd;
      }
      body.appendChild(frag);
      var qty = qs('lystia-qty', body);
      if (qty && qty.setValue) qty.setValue(inCart || this.qty);
      if (this.busy) {
        var b = qs('[data-bb-add]', body);
        this.setLoading(b, true, this.T.textAdding);
        if (qty && qty.setState) qty.setState('loading');
        body.appendChild(tpl(z, 'hint'));
      }
      if (atc && focused) { var nb = qs('[data-bb-add]', body); if (nb) nb.focus({ preventScroll: true }); }
    }

    async add(fromSticky) {
      var self = this;
      if (this.busy || !this.cart || !this.v.available) return;
      this.busy = true;
      this.error = false;
      this.draw();
      this.drawSticky();
      var qty = this.qty;
      var ok = false;
      this.silent = true;
      try {
        await this.cart.add({ id: this.v.id, quantity: qty });
        ok = true;
      } catch (e) {
        this.error = true;
      }
      this.silent = false;
      this.busy = false;
      if (ok) {
        this.qty = 1;
        this.draw();
        var ab = qs('[data-bb-add]', this.body);
        if (ab) ab.classList.add('is-justadded');
        this.drawSticky(true);
        toast(this.T.textToast, { icon: 'check', action: { label: this.T.textCart, onClick: function () { self.openCart(); } } });
        document.dispatchEvent(new CustomEvent('pdp:added', { detail: { id: this.v.id, quantity: qty, fromSticky: !!fromSticky } }));
      } else {
        this.draw();
        this.drawSticky();
        toast(this.T.textFailed, { icon: 'alert' });
      }
    }

    /* ---------- sticky-бар (лише M) ---------- */
    buildSticky() {
      var self = this;
      var frag = tpl(this.zone, 'sticky');
      var bar = qs('[data-bb-sticky]', frag);
      if (!bar) return;
      document.body.appendChild(frag);
      this.sticky = bar;
      this.stickyBtn = qs('[data-bb-sbtn]', bar);
      this.stickyBtn.addEventListener('click', function () {
        if (self.inCart()) self.openCart(); else self.add(true);
      });
    }

    drawSticky(justAdded) {
      var bar = this.sticky, v = this.v;
      if (!bar || !v) return;
      qs('.pdp-sticky__now', bar).textContent = fmtMoney(v.price, this.cur);
      var lbl = qs('.pdp-sticky__lbl', bar);
      lbl.textContent = v.label;
      lbl.hidden = !v.label;
      if (!v.available) {
        bar.classList.remove('is-on');
        bar.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('pdp-sticky-on');
        return;
      }
      var inCart = this.inCart();
      var btn = this.stickyBtn;
      var label = qs('.btn__label', btn);
      var ico = qs('.ico', btn);
      if (ico) ico.remove();
      btn.classList.remove('is-justadded');
      btn.classList.toggle('btn--primary', !inCart);
      btn.classList.toggle('btn--secondary', !!inCart);
      if (inCart) {
        btn.insertBefore(tpl(this.zone, 'check'), label);
        label.textContent = this.T.textInCart.replace('__Q__', String(inCart));
      } else {
        label.textContent = this.error ? this.T.textRetry : this.T.textAdd;
      }
      this.setLoading(btn, this.busy, this.busy ? this.T.textAdding : null);
      if (justAdded) btn.classList.add('is-justadded');
      this.updateSticky();
    }

    setStickyVisible(on) {
      this.wantSticky = on;
      this.updateSticky();
    }

    updateSticky() {
      var bar = this.sticky;
      if (!bar) return;
      var on = !!this.wantSticky && this.v.available && !(this.mqD && this.mqD.matches);
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('pdp-sticky-on', on);
    }

    watchSticky() {
      var self = this;
      var target = this.zone;
      this.wantSticky = false;
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { self.setStickyVisible(!en.isIntersecting && en.boundingClientRect.top < 0); });
        }, { threshold: 0 });
        this.io.observe(target);
      }
      /* запасний шлях (фонові вкладки, де IO може запізнюватись): та сама умова на scroll */
      window.addEventListener('scroll', function () {
        var lk = document.lystia && document.lystia.scrollLock;
        if (lk && lk.locked) return;
        self.setStickyVisible(target.getBoundingClientRect().bottom < 0);
      }, { passive: true });
      if (this.mqD && this.mqD.addEventListener) this.mqD.addEventListener('change', function () { self.updateSticky(); });
    }
  }

  function init() {
    var zone = qs('[data-bb-zone]');
    if (!zone || zone._lysBuybox) return;
    var root = zone.closest('[data-pdp]') || document;
    zone._lysBuybox = new Buybox(root, zone);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
